import React from 'react';
import { Lock } from 'lucide-react';

/**
 * PasswordCard Component
 * Карточка с информацией о пароле
 */
export const PasswordCard = ({ onOpenModal }) => {
  return (
    <div className="w-[682px] bg-white border border-[rgba(0,16,61,0.12)] rounded-xl overflow-hidden">
      {/* Заголовок */}
      <div className="bg-white px-5 py-4 flex items-center gap-3 border-b border-[rgba(0,16,61,0.12)]">
        <div className="w-8 h-8 bg-[#0dc268] rounded-full flex items-center justify-center">
          <Lock size={16} className="text-white" />
        </div>
        <h2 className="text-[#2c2d2e] text-[15px] font-normal">Пароль</h2>
      </div>

      {/* Контент */}
      <div className="px-16 py-5 space-y-5">
        <p className="text-[#87898f] text-[15px] leading-5">
          Надёжный пароль защищает почту от взлома. Если пароль простой,
          злоумышленники могут получить доступ, чтобы читать и удалять письма,
          отправлять спам. Также они могут использовать почту, чтобы взломать аккаунты в
          соцсетях, банках, играх, сервисах Apple и Google.
        </p>

        <button
          onClick={onOpenModal}
          className="bg-[rgba(0,16,61,0.06)] px-4 h-9 rounded-lg text-[#2c2d2e] text-[15px] hover:bg-[rgba(0,16,61,0.1)] transition-colors"
        >
          Изменить пароль
        </button>
      </div>
    </div>
  );
};

export default PasswordCard;